import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { MakeMoney } from '../../components/MakeMoney';
import { ActionContainer } from '../ActionContainer';

export const MakeMoneyContainer = () => {
  const device = useDeviceType();

  return <MakeMoney deviceType={device} action={<ActionContainer />} />;
};
